import CustomButton from '@components/shared/CustomButton';
import CustomText from '@components/shared/CustomText';
import PropTypes from 'prop-types';

import { useFormContext } from 'context/FormContext';
import { useRouter } from 'next/router';

import styles from './StepLayout.module.scss';

const StepLayout = ({
  children,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonStyle,
  secondaryButtonStyle,
  primaryButtonOnClick,
  secondaryButtonOnClick,
  primaryButtonDisabled,
  title,
  info,
}) => {
  const router = useRouter();
  const { guestId } = useFormContext();
  const onCancel = () => {
    router.push(`/${guestId || ''}`, '', { shallow: true });
  };
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <CustomText bold customStyle={styles.title}>
          {title}
        </CustomText>
        <CustomText customStyle={styles.info}>{info}</CustomText>
      </div>

      <div className={styles.content}>{children}</div>

      <div className={styles.buttons}>
        {secondaryButtonText && (
          <CustomButton
            text={secondaryButtonText}
            onClick={
              secondaryButtonText.toLowerCase() === 'cancel'
                ? () => onCancel()
                : () => secondaryButtonOnClick()
            }
            customStyle={secondaryButtonStyle}
            secondary
          />
        )}
        <CustomButton
          text={primaryButtonText}
          onClick={primaryButtonOnClick}
          disabled={primaryButtonDisabled}
          customStyle={primaryButtonStyle}
        />
      </div>
    </div>
  );
};

StepLayout.propTypes = {
  children: PropTypes.node,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  primaryButtonStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  secondaryButtonStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  primaryButtonOnClick: PropTypes.func,
  secondaryButtonOnClick: PropTypes.func,
  primaryButtonDisabled: PropTypes.bool,
  title: PropTypes.string,
  info: PropTypes.string,
};

export default StepLayout;
